<template>
  <div
    :class="[{ 'current-select': parent.value === value }, { 'is-disabled': disabled }, 'select-option']"
    @click.stop="optionChange({ label: label, value: value })"
  >
    <label :title="label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'PureOption',
  inject: ['parent'],
  props: {
    label: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    optionChange(option) {
      if (this.disabled) return
      this.parent.selectData.label = option.label
      this.parent.selectData.value = option.value
      this.parent.selectDom = this
    },
  },
  watch: {
    value() {
      this.parent.option.push({
        label: this.label,
        value: this.value,
      })
    },
  },
  created() {
    this.parent.option.push({
      label: this.label,
      value: this.value,
    })
  },
}
</script>

<style lang="less" scoped>
.select-option {
  height: 34px;
  line-height: 34px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  label {
    width: 100%;
    transition: 0.3s;
    font-size: 13px;
    padding: 0 0 0 18px;
    color: rgba(0, 0, 0, 0.5);
    cursor: inherit;
    
  }
  &:hover:not(.is-disabled) {
    label {
      color: #000;
    }
  }
}
.current-select {
  label {
    width: 100%;
    transition: 0.3s;
    font-size: 13px;
    color: #000;
    cursor: inherit;
    user-select: none;
  }
}
.is-disabled {
  cursor: not-allowed;
  label {
    color: #c0c4cc;
    user-select: none;
  }
}
</style>
